// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jz-1";
export var messageSideRight = "_jz-2";
export var orderLookupBubbleContainer = "_jz-0";
export var submitButton = "_jz-3";